import { Alert, Box, Button, CircularProgress } from '@mui/material';
import { Google } from '@mui/icons-material';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useUserContext } from './lib/users-context';
import Layout from './components/layout';
import RequireAdmin from './components/require-admin';
import CheckInPage from './pages/check-in-page';
import GroupsPage from './pages/groups-page';
import AdminPage from './pages/admin-page';
import ActivityLogPage from './pages/activity-log-page';
import AttendancePage from './pages/attendance-page';
import BirthdaysPage from './pages/birthdays-page';

const Wrapper = ({ children }: { children: React.ReactNode }) =>
  <Box sx={{ p: 4, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    {children}
  </Box>

const App = () => {
  const { isLoading, isLoggedIn, isEnabled, logIn } = useUserContext();

  if (isLoading) {
    return <Wrapper><CircularProgress /></Wrapper>;
  }

  if (!isLoggedIn) {
    return (
      <Wrapper>
        <Button onClick={logIn} variant="contained" startIcon={<Google />}>
          Log in with Google
        </Button>
      </Wrapper>
    );
  }

  if (!isEnabled) {
    return (
      <Wrapper>
        <Alert severity="error">Please contact admin for appoval of your account.</Alert>
      </Wrapper>
    );
  }

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<CheckInPage />} />
        {/* Manage is open to any enabled user — they get read + edit on
            groups / rotations / roster, but the destructive actions
            (delete) are gated inside the page. Admin remains admin-only. */}
        <Route path='manage' element={<GroupsPage />} />
        <Route path='birthdays' element={<BirthdaysPage />} />
        <Route path='attendance' element={<AttendancePage />} />
        <Route element={<RequireAdmin />}>
          <Route path='admin/activity-log' element={<ActivityLogPage />} />
          <Route path='admin' element={<AdminPage />} />
        </Route>
        <Route path='*' element={<Navigate to='/' replace />} />
      </Route>
    </Routes>
  );
};

export default App;
